export const Status = Object.freeze({
    connecting: 1,
    connected: 2,
    remoteConnected: 3,
    remoteDisconnected: 4,
    disconnected: 5
});